export default __webpack_public_path__ + "static/endc-3787b271486531ad552da70c86bc681f.jpg";